/* eslint-disable no-mixed-operators */
/* eslint-disable no-console */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';

import styles from './monkey-loading.css';

class MonkeyLoading extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
        ]);
        this.state = {
            status: '',
            left: -160
        };
    }
    componentDidMount () {
        this.start();
    }
    componentDidUpdate (prevProps) {
        if (prevProps.progress !== this.props.progress) {
            this.update();
        }
    }
    update () {
        if (this.frameId) window.cancelAnimationFrame(this.frameId);
        if (this.timeoutId) window.clearTimeout(this.timeoutId);
        this.start();
    }
    start () {
        const {progress, expansion} = this.props; // 100
        let {left} = this.state; // 160
        const maxLeft = progress / 100 * 160 - 160;
        const run = () => {
            if (left < maxLeft && left < 0) {
                left = left + 1;
                const progressFunc = () => {
                    this.setState({
                        left
                    }, () => {
                        this.frameId = window.requestAnimationFrame(run);
                    });
                };
                if (expansion) {
                    this.timeoutId = setTimeout(progressFunc, expansion);
                } else {
                    progressFunc();
                }
                
            }
            if (left >= 0) {
                if (this.frameId) window.cancelAnimationFrame(this.frameId);
                if (this.timeoutId) window.clearTimeout(this.timeoutId);

                this.setState({
                    status: 'loaded',
                    left: 0
                });
                setTimeout(() => {
                    if (this.props.onFinished) {
                        this.props.onFinished();
                    }
                }, 500);
            }
        };
        run();
    }

    render () {
        const {status, left} = this.state;
        const {content} = this.props;
        const percent = ((left + 160) * 100 / 160).toFixed(0);
        return (
            <div className={styles.loadingContainer}>
                <div className={styles.bgLink} />
                <div className={styles.monkey} />
                <div className={styles.wavesContainer}>
                    <div
                        className={styles.mix}
                        style={{left: `${left}px`}}
                    >
                        <div className={styles.waves} />
                        <div className={styles.monkeyHand} />
                    </div>
                </div>
                <div
                    className={classNames(styles.banana, {
                        [styles.bananaOn]: status === 'loaded'
                    })}
                />
                <div
                    className={classNames(styles.bananaInHand, {
                        [styles.bananaInHandOn]: status === 'loaded'
                    })}
                />
                <div className={styles.content}>{content[0]}{content.length === 1 ? '' : `${percent}%`}{content[1]}</div>
            </div >
        );
    }
}

MonkeyLoading.propTypes = {
    progress: PropTypes.number,
    // eslint-disable-next-line react/forbid-prop-types
    content: PropTypes.array,
    onFinished: PropTypes.func,
    expansion: PropTypes.number
};

export default MonkeyLoading;
